<template>
    <div class="trz_leave_settings pt-4">
        
        <b-overlay :show="showoverlay" rounded="sm" class="col-md-12">            
            
                    <div class="row ">                    
                        <div class="col-sm-8" >                    
                            <div class="card">                            
                                <div class="card-header table-head">
                                    Leave Year/Contract Date Range From {{startDate}} To {{endDate}}
                                </div> 
                                
                                <div class="card-body " v-if="available.length > 0">                
                                    <div class="row"> 
                                        
                                        <div class="col-sm-4">
                                            <b-form-group id="leave_date-group" label="Leave Date [YYYY-MM-DD]" label-for="leave_date">
                                                <b-input-group class="mb-3">
                                                    <b-form-datepicker id="leave_date" v-model="fdata.leave_date" class="mb-2"></b-form-datepicker>                                                    
                                                </b-input-group>
                                            </b-form-group>
                                        </div>
            
                                        <div class="col-sm-4">
                                            <b-form-group  id="rounding-group" label="Available Dates" class="required-field" label-for="rounding">
                                                <b-form-select id="rounding" name="rounding" v-model="fdata.attendance_date" :options="available" ></b-form-select>
                                            </b-form-group>
                                        </div>   
                                        
                                        <div class="col-sm-4 d-none">
                                            <b-form-group  id="status-group" label="Leave Status" class="required-field" label-for="status">
                                                <b-form-select id="status" name="status" v-model="fdata.status" v-validate="{  }" :options="status"></b-form-select>
                                            </b-form-group>                                            
                                        </div>
                                    </div>                           
            
                                    <div class='mt-2'>                             
                                        
                                        
                                        <div class="clearfix">                                            
                                            <div class="float-left"><b-button @click="saveLeave()">Save</b-button></div> 
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body " v-else>No available dates.</div>
                            </div>
                        </div>


                        <!----->
                        

                        
                    </div>

                    <div class="card mt-4">

                        <div class="col-sm-12">
                            <div class="card-header table-head">Allowed Leaves</div>
                            <div class="card-body ">   
                                <table class="table">
                                    <thead>
                                        <tr class="table-head">
                                            <th>Leave Date</th>
                                            <th>Used Attendance Date</th>

                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="table-row hover-bg" v-for="leave in compensatory_leave_list" :key="leave.id">
                                            <td>{{leave.leave_date}}</td>
                                            <td>{{leave.attendance_date}}</td>

                                            
                                            <td>{{ status[leave.status].text }}</td>

                                            <td><button @click="deleteLeave(leave.id)">Delete</button></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                    
                
            
        </b-overlay>
        
    </div>
</template>
<script>    
    
    import moment from 'moment'

    export default{
        
        mounted() {
            
        },
        props: [],   
        components: {
            
        },     
        data(){
            
            const now = new Date();
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
            

            return {

                startDate : null,
                endDate : null,

                showoverlay : false,
                              
                fdata : { leave_date:today , attendance_date:null , status:1},
                
                compensatory_leave_list : [],
                available : [],
                
                blankmsg : '',

                status: [
                    { text: 'Applied', value: '0' },
                    { text: 'Approved', value: '1' },
                    { text: 'Declined', value: '2' },
                ],
                
                
            }
        },
        methods:{
            
                        
            
            deleteLeave: function(id)
            {
                this.showoverlay = true;
                let formData = new FormData();
                formData.append('id', id);
                axios.post(this.$api_url+'/compensatory-leave-delete', formData)
                    .then(function (response) 
                    {    
                        this.$bvToast.toast('Deleted!', {
                                                title: `Success`,
                                                variant: 'success',
                                                solid: true
                                            });

                        this.getLeaves();
                    
                    }.bind(this))
                    .catch(function (error) 
                    {
                        this.showoverlay = false;
                        currentObj.showoverlay = false;
                        currentObj.serverError(error);
                    });
            },
            
            getLeaves:function() 
            {   
                this.showoverlay = true;
                axios.get(this.$api_url+'/compensatory-leave-list' , {
                    params: {
                        //id: x
                    }
                }).then(function(response){
                    
                    if(response.data.length != 0)
                    {
                        
                        this.compensatory_leave_list = response.data.compensatory_leave_list;
                        
                        this.available = response.data.available;


                        this.startDate =  response.data.leave_limit_start_date;
                        this.endDate =  response.data.leave_limit_end_date;


                        if(this.compensatory_leave_list.length == 0)
                        {
                            this.blankmsg = 'Looks like no leave applied for the employee yet.';
                        } 

                        
                    }
                    
                    this.showoverlay = false;
                    
                }.bind(this));

            },
            saveLeave:function(date)
            {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    let currentObj = this;
                    let formData = new FormData();
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    } 

                    this.showoverlay = true;

                    axios.post(this.$api_url+'/compensatory-leave-save', formData,)
                                .then(function (response) 
                                {                         
                                    this.getLeaves();                                   
                                    
                                }.bind(this))
                                .catch(function (error) 
                                {                  
                                    this.showoverlay = false;                  
                                    currentObj.serverError(error);
                                });
            
                });
            },            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            
        },
        created: function(){
            
            this.getLeaves();
        },
        computed: 
        {            

            
            
        }
    }
</script>
